import ProjectsList from 'features/all-projects/ProjectsList';

const AllProjectsPage = () => <ProjectsList />;

export default AllProjectsPage;
